import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogSource} from '../../../logging/data/logSource';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogLevel} from '../../../logging/data/logLevel';

/**
 * Angular default mappings
 */
@Component({
  selector: 'app-tab-view',
  templateUrl: './tab-view.component.html',
  styleUrls: ['./tab-view.component.scss']
})
export class TabViewComponent implements OnInit {

  /**
   * All the tab headers
   */
  @Input() tabHeaders: string[];
  /**
   * All the tab icons
   */
  @Input() tabHeadersIcons: string[];
  /**
   * The selected tab index
   */
  @Input() tabIndex = 0;
  /**
   * The selected tab index
   */
  @Output() tabIndexChange: EventEmitter<number> = new EventEmitter<number>();
  /**
   * Emitted when another tab is selected
   */
  @Output() onSelect: EventEmitter<string> = new EventEmitter<string>();

  /**
   * Default ctor
   */
  constructor(private loggerService: LoggerService) {
  }

  /**
   * Default initialization
   */
  ngOnInit() {
  }

  /**
   * Changes the selected tab
   * @param index the index of the newly selected tab
   */
  onTabClick(index: number) {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.TabViewComponent, `Tab ${this.tabHeaders[index]} clicked`);
    this.tabIndex = index;
    this.onSelect.emit(this.tabHeaders[this.tabIndex]);
    this.tabIndexChange.emit(this.tabIndex);
  }

}
